import { render } from "./work.vue?vue&type=template&id=0e560089&scoped=true"
import script from "./work.vue?vue&type=script&lang=js"
export * from "./work.vue?vue&type=script&lang=js"

import "./work.vue?vue&type=style&index=0&id=0e560089&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e560089"

export default script